"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Support = function Support(props) {
  return _react.default.createElement("svg", {
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 4.77091C15.659 4.77091 18.2291 7.341 18.2291 10.5001H19.2708C19.2708 8.70434 18.5574 6.98216 17.2877 5.71238C16.0179 4.4426 14.2957 3.72925 12.5 3.72925C10.7042 3.72925 8.98203 4.4426 7.71226 5.71238C6.44248 6.98216 5.72913 8.70434 5.72913 10.5001H6.77079C6.77079 7.341 9.34087 4.77091 12.5 4.77091Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18.75 19.3542H13.5416C13.4035 19.3542 13.271 19.2993 13.1734 19.2016C13.0757 19.1039 13.0208 18.9715 13.0208 18.8333C13.0208 18.6952 13.0757 18.5627 13.1734 18.465C13.271 18.3674 13.4035 18.3125 13.5416 18.3125H18.75C18.8881 18.3125 19.0206 18.3674 19.1183 18.465C19.2159 18.5627 19.2708 18.6952 19.2708 18.8333C19.2708 18.9715 19.2159 19.1039 19.1183 19.2016C19.0206 19.2993 18.8881 19.3542 18.75 19.3542Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 20.396C12.191 20.396 11.8889 20.3044 11.6319 20.1327C11.375 19.961 11.1747 19.7169 11.0564 19.4314C10.9382 19.1459 10.9072 18.8318 10.9675 18.5287C11.0278 18.2256 11.1766 17.9472 11.3951 17.7286C11.6137 17.5101 11.8921 17.3613 12.1952 17.301C12.4983 17.2407 12.8124 17.2717 13.0979 17.3899C13.3835 17.5082 13.6275 17.7085 13.7992 17.9654C13.9709 18.2224 14.0625 18.5245 14.0625 18.8335C14.062 19.2478 13.8973 19.6449 13.6043 19.9378C13.3114 20.2308 12.9143 20.3955 12.5 20.396ZM12.5 18.3127C12.397 18.3127 12.2963 18.3432 12.2106 18.4004C12.125 18.4577 12.0582 18.539 12.0188 18.6342C11.9794 18.7294 11.9691 18.8341 11.9892 18.9351C12.0093 19.0361 12.0589 19.1289 12.1317 19.2018C12.2046 19.2746 12.2974 19.3242 12.3984 19.3443C12.4994 19.3644 12.6041 19.3541 12.6993 19.3147C12.7945 19.2753 12.8758 19.2085 12.9331 19.1229C12.9903 19.0372 13.0208 18.9365 13.0208 18.8335C13.0207 18.6954 12.9657 18.563 12.8681 18.4654C12.7705 18.3677 12.6381 18.3128 12.5 18.3127Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M6.94442 10.5H5.38192C5.09427 10.5 4.86108 10.7332 4.86108 11.0208V15.1875C4.86108 15.4751 5.09427 15.7083 5.38192 15.7083H6.94442C7.23207 15.7083 7.46525 15.4751 7.46525 15.1875V11.0208C7.46525 10.7332 7.23207 10.5 6.94442 10.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18.2291 15.7085V18.7828C18.2291 18.9209 18.284 19.0534 18.3817 19.1511C18.4793 19.2487 18.6118 19.3036 18.75 19.3036C18.8881 19.3036 19.0206 19.2487 19.1182 19.1511C19.2159 19.0534 19.2708 18.9209 19.2708 18.7828V15.7085H18.2291Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M19.6181 10.5H18.0556C17.7679 10.5 17.5347 10.7332 17.5347 11.0208V15.1875C17.5347 15.4751 17.7679 15.7083 18.0556 15.7083H19.6181C19.9057 15.7083 20.1389 15.4751 20.1389 15.1875V11.0208C20.1389 10.7332 19.9057 10.5 19.6181 10.5Z",
    fill: props.foregroundColor
  }));
};

Support.defaultProps = {
  altText: "Support",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Support.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Support;
exports.default = _default;